module.exports = __webpack_public_path__ + "static/media/icon-parking.4dbe5cdc.svg";